import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useLocalizeMessage } from 'libs.nucleus';
export const useDimensionsColumns = () => {
    const translate = useLocalizeMessage();
    return useMemo(() => [
        {
            header: translate('Name'),
            accessorKey: 'title',
            cell: ({ row }) => _jsx("div", { className: 'font-medium', children: row.original.title }),
        },
        {
            header: translate('Type'),
            accessorKey: 'type',
        },
        {
            header: translate('Description'),
            accessorKey: 'description',
            cell: ({ row }) => row.original.description || '-',
        },
    ], [translate]);
};
